import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import CafeKasirRouter from './CafeKasirRouter';
import RetailIndex from './retail/index';
import ProtectedBranchRoute from './ProtectedBranchRoute';
import { apiHost } from '../../utils/apiHost';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

const KasirBranchRouter = () => {
  const authUser = useSelector((state) => state.auth.user);
  const [resolvedUser, setResolvedUser] = useState(authUser);
  const [loading, setLoading] = useState(!authUser?.cabang?.tipe_cabang);
  const [error, setError] = useState('');

  useEffect(() => {
    setResolvedUser(authUser);
    if (authUser?.cabang?.tipe_cabang) {
      setLoading(false);
      return;
    }

    let mounted = true;
    const fetchMe = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
        if (mounted) {
          setResolvedUser(response.data);
          setError('');
        }
      } catch (err) {
        if (mounted) {
          setError(err?.response?.data?.msg || 'Gagal memuat data cabang kasir.');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchMe();
    return () => {
      mounted = false;
    };
  }, [authUser]);

  const branchType = useMemo(
    () => resolvedUser?.cabang?.tipe_cabang || authUser?.cabang?.tipe_cabang || '',
    [resolvedUser, authUser]
  );

  if (loading) {
    return (
      <Box sx={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  // Protected route untuk Cafe
  if (branchType === 'cafe') {
    return (
      <ProtectedBranchRoute requiredBranchType="cafe">
        <CafeKasirRouter />
      </ProtectedBranchRoute>
    );
  }

  // Protected route untuk Retail/Toko
  if (branchType === 'retail/toko') {
    return (
      <ProtectedBranchRoute requiredBranchType="retail/toko">
        <RetailIndex />
      </ProtectedBranchRoute>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Alert severity="warning">
        <Typography variant="body2">
          Tipe cabang belum dikenali. Silakan cek konfigurasi cabang Anda terlebih dahulu.
        </Typography>
      </Alert>
    </Box>
  );
};

export default KasirBranchRouter;
